module.exports = __webpack_public_path__ + "img/dinkenclave-3.5d7db822.jpeg";